const videos = [
  {
    title: '《流浪地球3》终极预告 - 人类命运之战',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20space%20battle%20scene%20with%20massive%20spaceships%20and%20cosmic%20explosions%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20cinematic%20widescreen%2C%20scifi%20blockbuster%20aesthetic%2C%20high%20contrast%2C%20professional%20movie%20poster%20quality&width=800&height=450&seq=media-1-ql&orientation=landscape',
    duration: '02:35',
    views: '128.6万',
  },
  {
    title: '《长安十二时辰》精彩片段混剪',
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battle%20scene%20with%20warriors%20in%20armor%2C%20dramatic%20lighting%20at%20sunset%2C%20dust%20and%20smoke%20atmosphere%2C%20cinematic%20action%20composition%2C%20warm%20golden%20tones%2C%20epic%20scale&width=800&height=450&seq=media-2-ql&orientation=landscape',
    duration: '04:18',
    views: '95.3万',
  },
  {
    title: '2026 暑期档十大期待影片盘点',
    poster: 'https://readdy.ai/api/search-image?query=Movie%20poster%20collage%20style%20with%20vibrant%20colors%2C%20cinematic%20lighting%2C%20film%20strip%20elements%2C%20dramatic%20spotlights%2C%20warm%20theater%20atmosphere%2C%20professional%20entertainment%20aesthetic&width=800&height=450&seq=media-3-ql&orientation=landscape',
    duration: '06:42',
    views: '76.8万',
  },
  {
    title: '《繁花》王家卫美学镜头全解析',
    poster: 'https://readdy.ai/api/search-image?query=Art%20deco%20Shanghai%20interior%20with%20warm%20golden%20lamplight%2C%20elegant%20vintage%20furniture%2C%20smoke%20and%20mirrors%20atmosphere%2C%20cinematic%20noir%20composition%2C%20rich%20amber%20and%20shadow%2C%20old%20world%20glamour&width=800&height=450&seq=media-4-ql&orientation=landscape',
    duration: '05:10',
    views: '63.4万',
  },
  {
    title: '高分韩剧《黑暗荣耀》剧情深度解读',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20Korean%20drama%20aesthetic%20with%20moody%20lighting%2C%20rain%20on%20window%2C%20minimalist%20composition%2C%20cold%20blue%20and%20warm%20amber%20contrast%2C%20atmospheric%20cinematic%20quality%2C%20emotional%20tension&width=800&height=450&seq=media-5-ql&orientation=landscape',
    duration: '08:21',
    views: '52.1万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            精选视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            热门预告、精彩剪辑、深度解读，用视频感受影视魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {videos.map((video, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={video.poster}
                  alt={video.title}
                  className="w-full h-44 md:h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-all duration-200 group-hover:scale-110 shadow-lg">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium backdrop-blur-sm">
                  {video.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {video.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}